
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChevronTrippleLeft as ObiChevronTrippleLeftElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chevron-tripple-left.js';
 
 
 

 
 export const ObiChevronTrippleLeft = createComponent({
   react: React,
   tagName: 'obi-chevron-tripple-left',
   elementClass: ObiChevronTrippleLeftElement,
   events: {
     
   }
  });
 
 